function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types'; // import { Tooltip as ReactTooltip } from 'react-tippy'

import { Tooltip as ReactTooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css'; // import './tooltip.scss';

import { normalizeSize } from '../../utils';

var Tooltip = function Tooltip(props) {
  var width = props.width,
      className = props.className,
      children = props.children,
      content = props.content,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["width", "className", "children", "content", "size"]);

  var tooltipClass = classNames('br-4 ta-left elevation-3', {
    'py-1 px-2 fs-1': size === 'sm',
    'py-3 px-4': size === 'md'
  }, className);
  return React.createElement(ReactTooltip, _extends({}, otherProps, {
    size: size,
    arrowSize: size === 'sm' ? 'small' : 'regular',
    html: React.createElement("div", {
      className: tooltipClass,
      style: {
        maxWidth: normalizeSize(width)
      }
    }, content)
  }), children);
};

Tooltip.propTypes = {
  width: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md'])
};
Tooltip.defaultProps = {
  size: 'md',
  width: '100%',
  content: '',
  children: '',
  className: ''
};
export { Tooltip };